import { delve } from '@mylo/dlv-and-dset'

export default function evaluate (condition, values, prefix) {
  const pattern = /(\{\{[a-zA-Z0-9._\[\]]+\}\})/i
  let logic = condition
  // replace {{$}} with the prefix
  const prefixPattern = /(\{\{\$\}\})/
  while (prefixPattern.test(logic)) {
    logic = logic.replace(prefixPattern, prefix)
  }
  // replace $ with the prefix
  if (/\$/.test(logic)) {
    logic = logic.replace(/\$/g, prefix)
  }
  while (pattern.test(logic)) {
    logic = logic.replace(pattern, match => {
      const path = match.slice(2, -2)
      const value = delve(values, path)
      if (typeof value === 'string') {
        return '"' + value + '"'
      }
      return value
    })
  }

  let result
  try {
    result = !!eval(logic)
  } catch (error) {
    result = false
  }
  return result
}
